import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	position: relative;
	gap: 1em;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 34%;
	top: -5%;
	flex-direction: row;
`;
